import { easings } from 'react-spring'
import { __enforceTypescriptConstraint } from '@feedyou/utils'
import { StageDefinition } from '../../../../lib/useAnimationStageTimelines'

export const dropzoneAnimationStages = [
  {
    name: 'bottomZoneSlideDown',
    duration: 250,
    easing: easings.easeInOutCubic,
    stageOverflow: { right: 150 }
  },
  {
    name: 'overlayFadeIn',
    duration: 1,
    easing: easings.linear,
    stageOverflow: { left: 250 }
  },
  { name: 'delay', duration: 100, easing: easings.easeInOutElastic },
  { name: 'borderShrink', duration: 200, easing: easings.linear },
  {
    name: 'labelAppear',
    duration: 250,
    easing: easings.easeInOutCubic,
    stageOverflow: { left: 100 }
  }
] as const

__enforceTypescriptConstraint<readonly StageDefinition[]>(dropzoneAnimationStages)
